import React, { Component, PropTypes } from "react"
import Modal from "react-modal"
import { connect } from "react-redux"
import { taskCreatorModalToggle, taskCreatorGenerateWithRelations } from "../../state/actions"
import TaskCreatorForm from "./taskCreatorForm"

const modalStyle = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "rgba(255, 255, 255, 0.75)"
    },
    content: {
        position: "relative",
        top: "initial",
        bottom: "initial",
        left: "initial",
        right: "initial",
        maxHeight: "90%",
        overflow: "auto",
        padding: "0"
    }
}

@connect(
    ({taskCreator: {modalIsOpen, error, statusText}}) => ({modalIsOpen, error, statusText}),
    {taskCreatorModalToggle, taskCreatorGenerateWithRelations}
)

/**
 * Task creator implements a modal interface to convert an entity or a group of entities as a task|tasks
 * this component requires some properties
 */
export default class TaskCreator extends Component {
    static propTypes = {
        modalTitle: PropTypes.string.isRequired,
        taskItems: PropTypes.arrayOf(PropTypes.object),
        staffItems: PropTypes.arrayOf(PropTypes.object),
        convertionType: PropTypes.string.isRequired,
        modalIsOpen: PropTypes.bool,
        taskCreatorModalToggle: PropTypes.func.isRequired,
        taskCreatorGenerateWithRelations: PropTypes.func.isRequired,
    }

    render() {
        return (
            <div>
                <Modal isOpen={this.props.modalIsOpen} style={modalStyle} contentLabel={""}>
                    <TaskCreatorForm {...this.props} />
                </Modal>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./components/taskCreator/index.jsx